import { render, staticRenderFns } from "./jqs_zonghe_mx.vue?vue&type=template&id=6acb827e&scoped=true"
import script from "./jqs_zonghe_mx.vue?vue&type=script&lang=js"
export * from "./jqs_zonghe_mx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acb827e",
  null
  
)

export default component.exports